import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
 
const CheckButton = ({ name, display, initialValue, tooptip }) => {
    const [val, setVal] = useState(initialValue);
    
    return (
        <span style={{margin: "5px"}} data-toggle="tooltip" title={tooptip}>
            <Form.Control type='checkbox' name={`q[${name}]`} value={val} checked={val==="1"} onChange={()=>{}} style={{display: 'none'}}/>
            <button
                type="button"
                className={`btn btn-mod btn-border btn-circle btn-custom-mod ${val==="1" ? "btn-mod-on" : "btn-mod-off"}`}
                style={{
                    background: val === "1"  ? "#71b46a" : "white",
                    color: val === "1" ? "white" : "#71b46a"
                }}
                onClick={(e) => {
                    setVal(val === "1" ? "" : "1");
            }}>
                {display}
            </button>
        </span>
    );
}

export default CheckButton;